"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shouldFetchMorePlaylistTasks;

function shouldFetchMorePlaylistTasks(_ref) {
  var currentIndex = _ref.currentIndex,
      taskIds = _ref.taskIds,
      pageSize = _ref.pageSize,
      total = _ref.total;

  if (taskIds.size === total) {
    return false;
  } // Once we're at this threshold we should re-fetch.
  // If we fetch twice as much as our buffer size we can fetch less frequently


  var tasksBufferSize = Math.floor(pageSize / 2);
  var fetchUntilIndex = currentIndex + tasksBufferSize < total ? currentIndex + tasksBufferSize : total - 1;

  if (taskIds.size <= fetchUntilIndex) {
    return true;
  }

  return false;
}

module.exports = exports.default;